import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Paper,
    Button,
    IconButton,
    Tooltip,
    Stack,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
    // DataGrid,
    GridToolbarContainer,
    // GridToolbarColumnsButton,
    // GridToolbarFilterButton,
    // GridToolbarExport,
    // GridToolbarDensitySelector,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../Theme";
import store from "../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
// import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
    fetchApidata,
    explorePostData,
    postData,
    getFetchData,
    requestMail,
    ApprovalVerify,
    PermissionApprovalVerify,
} from "../../store/reducers/Formapireducer";
import { toast } from "react-hot-toast";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
//import { CheckinAutocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CryptoJS from "crypto-js";


const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const PermissionApproval = ({ appId, empId }) => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const mode = params.Mode;
    const dispatch = useDispatch();
    var CompanyID = sessionStorage.getItem("companyId");
    const [open, setOpen] = useState(false);
    var recID = decryptDataUrlSafe(params.id);
    var accessID = params.accessID;
    // const { toggleSidebar, broken, rtl } = useProSidebar();
    const listViewData = useSelector((state) => state.listviewApi.rowData);
    const listViewColumn = useSelector((state) => state.listviewApi.columnData);
    const [showtable, setShowtable] = useState(false);
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const data = useSelector((state) => state.formApi.Data);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [show, setScreen] = React.useState("0");
    const [files, setFiles] = useState([]);
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const EMPID = sessionStorage.getItem("EmpId");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        dispatch(getFetchData({ accessID: "TR266", get: "get", recID })).then((res) => {
            console.log(res, "response");
            console.log(res.payload.Data.EmployeeID, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: res.payload.Data.EmployeeID,
                        appId: recID
                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));

        })
    }, []);


    const [proName, setProName] = useState(null);

    const currentDate = new Date().toISOString().split('T')[0];
    console.log(data.ProjectID, "--data.ProjectID");

    const InitialValue = {
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        permissiondate: data.PermissionDate,
        fromtime: data.FromTime,
        totime: data.ToTime,
        location: data.Location,
        reason: data.Reasons,
        Status: data.Status,
        password: "",

    };
    const FNsave = async (values, resetForm, del) => {
        setLoading(true);
        // console.log(funMode, "+  funMode");
        console.log(data, "--data.ProjectID");
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        // const idata = {
        //     //RecordID:leaveData.recordID,
        //     RecordID: data.RecordID,
        //     AppliedDate: values.applieddate,
        //     PermissionDate: values.permissiondate,
        //     ToTime: values.totime,
        //     FromTime: values.fromtime,
        //     Location: values.location,
        //     EmployeeID: mode == "M" ? params.parentID : EMPID,
        //     ManagerComments: values.managerComments ? values.managerComments : "",
        //     Reasons: values.reason,
        //     Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status, Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status,
        //     Source: "Self",
        //     // ManagerComments:"",
        //     CompanyID

        // };
        const response = await dispatch(
            PermissionApprovalVerify({
                // action: "update",
                // DailyTaskRecordID: recID,
                // ApprovedBy: params.managerID,
                // Status: values.status,
                // PASSWORD: values.password,
                // ManagerComments: values.ManagerComments ? values.ManagerComments : "",
                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.status,
                Type: "P",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.status == "AP" ? "Y" : values.status == "RJ" ? "N" : "Q",
                Type: "P"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/P/${values.status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }
    };

    function LeaveTool() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {/* <Typography>{(show == "2" ? "List of Leave" :show == "6" ? "List of OT" : (show == "1" ? "List of Allowance" :"List of Deductions"))}</Typography> */}

                    <Typography variant="h5">List of OT{`(${rowCount}))`}</Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <GridToolbarQuickFilter />
                    <Tooltip title="ADD">
                        <IconButton type="reset">
                            <AddOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </GridToolbarContainer>
        );
    }
    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
    );
    const explorelistViewColumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    const screenChange = (event) => {
        setScreen(event.target.value);
    };
    const VISIBLE_FIELDS = [
        "SLNO",
        "OtDate",
        "NumberOfHours",
        "Status",
        "action",
    ];
    const [funMode, setFunMode] = useState("A");
    const columns = React.useMemo(
        () =>
            explorelistViewColumn
                ? explorelistViewColumn.filter((column) =>
                    VISIBLE_FIELDS.includes(column.field)
                )
                : [],
        [explorelistViewColumn]
    );

    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', data.EmployeeID);
        formData.append('appId', data.RecordID);
        formData.append('type', "P");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("📦 FormData contents:");
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            //setShowtable(true);
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
        else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading && <LinearProgress />}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        {/* {broken && !rtl && (
                            <IconButton onClick={() => toggleSidebar()}>
                                <MenuOutlinedIcon />
                            </IconButton>
                        )} */}
                        <Typography variant="h5">Permission</Typography>
                    </Box>
                    <Box display="flex">
                        <Tooltip title="Close">
                            <IconButton onClick={() => fnLogOut("Close")} color="error">
                                <ResetTvIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Logout">
                            <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                                <LogoutOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                    </Box>

                </Box>
            </Paper>

            {!getLoading ? (


                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}


                    <Formik
                        initialValues={InitialValue}
                        enableReinitialize={true}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                FNsave(values, resetForm, false);

                            }, 100);
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gap={formGap}
                                    padding={1}
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}

                                >

                                    <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>

                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                        // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                        />

                                        <TextField
                                            name="permissiondate"
                                            type="date"
                                            id="permissiondate"
                                            label="Permission Date"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ readOnly: true }}
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.permissiondate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.permissiondate && !!errors.permissiondate}
                                            helperText={touched.permissiondate && errors.permissiondate}
                                            sx={{ gridColumn: "span 2" }}
                                            // inputProps={{
                                            //     max: new Date().toISOString().split("T")[0],
                                            //     readOnly: true,
                                            // }}
                                            required
                                        // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                        />
                                        {!showImage ? <React.Fragment>
                                            <FormControl
                                                sx={{
                                                    //gridColumn: "span 2",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    //background: "#fff6c3"
                                                }}
                                            >
                                                <TextField
                                                    // disabled={
                                                    //     mode == "E" &&
                                                    //     values.Status != "AL" &&
                                                    //     values.Status != "QR"
                                                    // }
                                                    fullWidth
                                                    variant="standard"
                                                    type="time"
                                                    id="fromtime"
                                                    name="fromtime"
                                                    inputFormat="HH:mm:aa"
                                                    value={values.fromtime}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    label="From Time"
                                                    focused
                                                    inputProps={{ readOnly: true }}
                                                    required
                                                // inputProps={{ maxLength:20}}
                                                />
                                            </FormControl>
                                            <FormControl
                                                sx={{
                                                    //gridColumn: "span 2",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    //background: "#fff6c3"
                                                }}
                                            >
                                                <TextField
                                                    // disabled={
                                                    //     mode == "E" &&
                                                    //     values.Status != "AL" &&
                                                    //     values.Status != "QR"
                                                    // }
                                                    fullWidth
                                                    variant="standard"
                                                    type="time"
                                                    id="totime"
                                                    name="totime"
                                                    inputFormat="HH:mm:aa"
                                                    value={values.totime}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    label="To Time"
                                                    focused
                                                    required
                                                    inputProps={{ readOnly: true }}
                                                />
                                            </FormControl>

                                            <TextField
                                                //disabled={data.TaskSource === "Manager" || data.Status === "Approved"}
                                                // disabled={
                                                //     mode == "E" &&
                                                //     values.Status != "AL" &&
                                                //     values.Status != "QR"
                                                // }
                                                name="location"
                                                type="text"
                                                id="location"
                                                label="Location"
                                                variant="standard"
                                                focused
                                                value={values.location}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                sx={{ gridColumn: "span 2" }}
                                                inputProps={{ readOnly: true }}
                                            //required
                                            />
                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}

                                                // disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Reason"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.reason}
                                                id="reason"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="reason"
                                                error={!!touched.reason && !!errors.reason}
                                                helperText={touched.reason && errors.reason}
                                                inputProps={{ readOnly: true }}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                focused
                                            />
                                            {/* {mode == "M" || (mode == "E" && (values.Status == "RJ" || values.Status == "RC")) ? ( */}
                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL"}

                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"

                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />
                                            {/* ) : false} */}
                                            {/* {mode == "M" && ( */}
                                            {/* <TextField
                                                    select
                                                    label="Status"
                                                    id="Status"
                                                    name="Status"
                                                    value={values.Status}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    required
                                                    focused
                                                    variant="standard"
                                                >
                                                    {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                                                    <MenuItem disabled={mode != "M"} value="AP">
                                                        Approved
                                                    </MenuItem>
                                                    <MenuItem disabled={mode != "M"} value="RJ">
                                                        Rejected
                                                    </MenuItem>
                                                    {mode == "M" && (
                                                        <MenuItem value="QR">Query</MenuItem>
                                                    )}
                                                </TextField> */}
                                            {/* )} */}
                                            <FormControl
                                                focused
                                                variant="standard"
                                                sx={{ gridColumn: "span 2" }}
                                            >
                                                <InputLabel id="status">Status</InputLabel>
                                                <Select
                                                    // disabled={mode === "V" || mode == "TO"}
                                                    labelId="demo-simple-select-filled-label"
                                                    id="status"
                                                    name="status"
                                                    value={values.status}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem value="AP">Approved</MenuItem>
                                                    <MenuItem value="RJ">Rejected</MenuItem>
                                                    <MenuItem value="QR">Query</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {/* {mode == "E" && values.Status == "AP" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                                    Your Permission Approved.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "RJ" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                                    Your Permission Rejected.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "QR" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                                    Your Permission Status Query.
                                                </Alert>
                                            )} */}

                                        </React.Fragment> : false}

                                    </FormControl>


                                    {/* {mode === "IM" && (
                                            <ArrowDownwardIcon
                                                color="info"
                                                onClick={() => setShowImage((prev) => !prev)}
                                                sx={{ cursor: "pointer" }}
                                            />
                                        )} */}


                                    {/* <Box
                                        display="flex"
                                        padding={1}
                                        justifyContent="flex-end"
                                        mt="2px"
                                        gridColumn="span 4"
                                        gap={2}
                                    >
                                        
                                        {mode == "IM" && (
                                            <>
                                                <TextField
                                                    name="purpose"
                                                    type="text"
                                                    id="purpose"
                                                    label="Purpose"
                                                    variant="standard"
                                                    focused
                                                    value={values.purpose}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    error={!!touched.purpose && !!errors.purpose}
                                                    helperText={touched.purpose && errors.purpose}
                                                    sx={{ gridColumn: "span 2", height: "20px" }}
                                                    InputLabelProps={{ shrink: true }}

                                                />

                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <FileUploadIconButton onFileSelect={(file) => {
                                                        fileUpload(
                                                            file,
                                                            data.EmployeeID,
                                                            "upload",
                                                            "",
                                                            values.purpose
                                                        )
                                                        setFieldValue("purpose", "");
                                                    }}
                                                    />
                                                </Box>
                                            </>
                                        )}
                                        {mode != "M" && (values.Status == "AL" || values.Status == "RC" || mode == "A") && (
                                            <LoadingButton
                                                disabled={mode == "IM"}
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                                loading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                        )}
                                        {mode == "M" && (

                                            <LoadingButton
                                                disabled={mode == "IM"}
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                                loading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                        )}
                                        {mode != "M" && values.Status == "AL" && (
                                            <Button
                                                color="error"
                                                variant="contained"
                                                disabled={mode == "IM"}
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: `Do you want Delete?`,
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Confirm",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            FNsave(values, resetForm, "harddelete");
                                                            // navigate(-1);
                                                        } else {
                                                            return;
                                                        }
                                                    });
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        )}
                                        {mode == "M" && (
                                            <Button
                                                color="error"
                                                variant="contained"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: `Do you want Delete?`,
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Confirm",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            FNsave(values, resetForm, "harddelete");
                                                            // navigate(-1);
                                                        } else {
                                                            return;
                                                        }
                                                    });
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        )}

                                        <Button
                                            type="reset"
                                            color="warning"
                                            variant="contained"
                                            onClick={() => {
                                                navigate(-1);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <FileListPopup
                                            open={open}
                                            onClose={() => setOpen(false)}

                                            appId={recID}
                                            empId={EMPID}
                                        />
                                    </Box> */}

                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                // flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                           Your Permission request has been Approved.
                                        </Alert>
                                    )}

                                    {data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Permission request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Permission request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        // sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.Status == "AP" || data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>

                        )}
                    </Formik>

                    {/* </Box> */}
                </Paper>

            ) : (
                false
            )}
            {mode === "IM" && files.length > 0 ? (
                <Box mt={2}
                >
                    <Paper elevation={3} sx={{ padding: 2 }}>
                        {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
                        <TableContainer component={Paper} >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={rowSx}>
                                        <TableCell width={20}><strong>SL#</strong></TableCell>
                                        <TableCell width={160}><strong>Uploaded Date</strong></TableCell>
                                        <TableCell width={250}><strong>Filename</strong></TableCell>
                                        <TableCell width={150}><strong>Purpose</strong></TableCell>
                                        <TableCell width={100}><strong>Source</strong></TableCell>
                                        <TableCell ><strong>View</strong></TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {files.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No files uploaded yet.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        files.map((file, index) => (
                                            <TableRow key={file.id || index} sx={rowSx}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{file.uploadedDate}</TableCell>
                                                <TableCell>{file.filename}</TableCell>
                                                <TableCell>{file.purpose}</TableCell>
                                                <TableCell>{file.source}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Open File">
                                                        <IconButton
                                                            color="primary"
                                                            component="a"
                                                            href={file.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => fileUpload(
                                                                "",
                                                                data.EmployeeID,
                                                                "delete",
                                                                file.id,
                                                                file.purpose
                                                            )}
                                                            size="small"
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            ) : null}
        </React.Fragment>
    );
};

export default PermissionApproval;
